import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Typography } from "@parkschannel/ui";
export const PlannerChecklistHeading = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-4 md:mb-6 mt-1 shrink",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h4",
                component: "h2",
                className: "text-neutral-800 mb-3",
                children: "Fill Out Your Checklist"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "bodyXL",
                className: "text-neutral-700",
                children: "These tabs list items our experts recommend. Check boxes for things you already have, explore our suggestions, then save and share."
            })
        ]
    });
};
